import OktaAuth, {
  OktaAuthOptions,
  TransactionMetaOptions,
} from '@okta/okta-auth-js';

import { ConfigService } from '@/services';

const config: OktaAuthOptions = {
  issuer: `${ConfigService.OKTA_DOMAIN}/oauth2/default`,
  clientId: ConfigService.OKTA_CLIENT_ID,
  redirectUri: ConfigService.OKTA_REDIRECT,
  clientSecret: ConfigService.OKTA_CLIENT_SECRET,
  pkce: true,
};
export const oktaAuth = new OktaAuth(config);

const load = oktaAuth.transactionManager.load;

oktaAuth.transactionManager.load = (options: TransactionMetaOptions = {}) => {
  const data = load.bind(oktaAuth.transactionManager)(options);
  if (data)
    data.urls = {
      ...((data.urls as Record<string, string>) || {}),
      tokenUrl: `${ConfigService.BACKEND_REST_ENDPOINT}/okta/token`,
    };
  return data;
};
